import { HtmlPreview } from '@/components/ui/custom/dataDisplay/HtmlPreview';
import { Project } from '@/models/Project';
import { ProjectSectionContainer } from './ProjectSectionContainer';

export const ProjectDescription = ({
  description,
}: Pick<Project, 'description'>) => {
  return (
    <ProjectSectionContainer title="Descrição">
      <HtmlPreview html={description} />
    </ProjectSectionContainer>
  );
};
